var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", { staticClass: "modal-h1 mb-3" }, [
      _c("button", {
        staticClass: "btn btn-back",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.$emit("cancel")
          }
        }
      }),
      _vm._v("\n    Create User\n  ")
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        attrs: { autocomplete: "no" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.create($event)
          },
          keydown: function($event) {
            _vm.clearError($event)
          }
        }
      },
      [
        _c("div", { staticClass: "l-bg-white" }, [
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6 pl-1 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("First name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.first_name,
                        expression: "user.first_name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter First Name" },
                    domProps: { value: _vm.user.first_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "first_name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "first_name" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pl-1 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Last name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.last_name,
                        expression: "user.last_name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Last Name" },
                    domProps: { value: _vm.user.last_name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "last_name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "last_name" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6 pl-1 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Email")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.email,
                        expression: "user.email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "email", placeholder: "Enter Email" },
                    domProps: { value: _vm.user.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "email", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "email" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-6 pl-1 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Phone")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.phone,
                        expression: "user.phone"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      placeholder: "Enter Phone",
                      maxlength: "14"
                    },
                    domProps: { value: _vm.user.phone },
                    on: {
                      keydown: function($event) {
                        _vm.maskPhone($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "phone", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "phone" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-6 pl-1 pr-1" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Username")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.username,
                        expression: "user.username"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Enter Username" },
                    domProps: { value: _vm.user.username },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "username", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "username" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-6 pl-1 pr-1" }, [
              _c("div", { staticClass: "d-flex align-items-center pl-2" }, [
                _c("span", { staticClass: "pr-2" }, [
                  _vm._v(
                    "\n              Receive automated update emails\n            "
                  )
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "switch mr-2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.receive_notifications,
                        expression: "user.receive_notifications"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.user.receive_notifications)
                        ? _vm._i(_vm.user.receive_notifications, null) > -1
                        : _vm.user.receive_notifications
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.user.receive_notifications,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.user,
                                "receive_notifications",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.user,
                                "receive_notifications",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.user, "receive_notifications", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "slider round" })
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-12 pl-1 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Carriers")]),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.listCarriers,
                        multiple: true,
                        "clear-on-select": false,
                        "hide-selected": true,
                        "preserve-search": false,
                        label: "name",
                        "track-by": "id"
                      },
                      on: { input: _vm.handleSelectAllCarriers },
                      scopedSlots: _vm._u([
                        {
                          key: "tag",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "multiselect__tag" }, [
                                _c("span", [_vm._v(_vm._s(props.option.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "multiselect__tag-icon",
                                  on: {
                                    click: function($event) {
                                      props.remove(props.option)
                                    }
                                  }
                                })
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.user.carriers,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "carriers", $$v)
                        },
                        expression: "user.carriers"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "carrier" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-12 pl-1 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Company")]),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.listCompanies,
                        multiple: true,
                        "clear-on-select": false,
                        "hide-selected": true,
                        "preserve-search": false,
                        label: "name",
                        "track-by": "id"
                      },
                      on: { input: _vm.handleSelectAllCompanies },
                      scopedSlots: _vm._u([
                        {
                          key: "tag",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "multiselect__tag" }, [
                                _c("span", [_vm._v(_vm._s(props.option.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "multiselect__tag-icon",
                                  on: {
                                    click: function($event) {
                                      props.remove(props.option)
                                    }
                                  }
                                })
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.user.companies,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "companies", $$v)
                        },
                        expression: "user.companies"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "companies" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mb-3" }, [
            _c(
              "div",
              { staticClass: "col-12 pl-1 pr-1" },
              [
                _c(
                  "div",
                  { staticClass: "select-wrap" },
                  [
                    _c("label", [_vm._v("Role")]),
                    _vm._v(" "),
                    _c("key-multiselect", {
                      attrs: {
                        options: _vm.rolesFromCarrier,
                        multiple: true,
                        "clear-on-select": false,
                        "hide-selected": true,
                        "preserve-search": false,
                        label: "name",
                        "track-by": "id"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "tag",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "multiselect__tag" }, [
                                _c("span", [_vm._v(_vm._s(props.option.name))]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "multiselect__tag-icon",
                                  on: {
                                    click: function($event) {
                                      props.remove(props.option)
                                    }
                                  }
                                })
                              ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.user.roles,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "roles", $$v)
                        },
                        expression: "user.roles"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "roles" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mvb-3" }, [
            _c("div", { staticClass: "col-12 pl-1 pr-1" }, [
              _c(
                "div",
                { staticClass: "select-wrap" },
                [
                  _c("label", [_vm._v("Timezone")]),
                  _vm._v(" "),
                  _c("simple-select", {
                    attrs: {
                      options: _vm.timezones,
                      placeholder: "Select time zone"
                    },
                    model: {
                      value: _vm.user.timezone,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "timezone", $$v)
                      },
                      expression: "user.timezone"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-5" }, [
      _c("div", { staticClass: "col" }, [
        _c("button", { staticClass: "btn btn-primary float-right" }, [
          _vm._v("Create")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab3215c6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab3215c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UsersCreate.vue
// module id = null
// module chunks = 